import AppPaths from '../../all/AppPaths'
export default AppPaths